import type { FaireProductEntity } from "../../entity_types/product";

export const p_7pm7ysksec: FaireProductEntity = {
  token: "p_7pm7ysksec",
  type: "product",
  name: "Crystallized chalcedony pendant",
  brandToken: "b_gy2hjqt9aj",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/97296f2f9c8945cd75e67c59231569fd08ea22768ddf4350609c0862f36b2238.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aa81d2bd61597c6893c94069a99490b8174754694ca5e620911e1d539fad9be8.jpeg",
    "https://cdn.faire.com/fastly/a63fe5aa4b4983bd011351d4642dae2ff18929a816dae27d771b8a9a2674fc43.jpeg",
    "https://cdn.faire.com/fastly/f912128bdf5f099db08773206ae912578d5c8715b13bbdf816472ae50d7d79b1.jpeg",
    "https://cdn.faire.com/fastly/1119f26a323b0145bb679875dbac4630604f939efd59de032a9d13b0578c8cee.jpeg",
    "https://cdn.faire.com/fastly/8730a8566401d90a981811d7eeaa932f4d3cbd28308d5c8efd9c1eb056fdd6b7.jpeg",
    "https://cdn.faire.com/fastly/94df93a1379879d571f79d4a7182ea28e88a0a5bba3e2c8770465bd318bda35a.jpeg",
    "https://cdn.faire.com/fastly/7c86295b1be28a49b61733d6f989be47cb03dbfb5180ac307966f7b79d5a2ce4.jpeg",
  ],
  priceDollars: 7.35,
  description:
    "Crystallized chalcedony pendants in various shapes.\n\nThese pendants are made from raw crystallized chalcedony, also called chalcedony flower.\n\nThey are rustic and unique pieces that retain all the natural beauty of the chalcedony, so no two pendants are the same.\n\nThe sizes also vary but in general each one measures 3 cm to 4 cm.\n\nThey are cut and set by hand and come from Brazil.\n\nThere are several formats available, all of them very original.\n\nThe edges of the pendants have an electroplated silver finish with a slight golden tint.\n\nThe images show samples of the pendants.",
  tags: [],
  msrpDollars: 14.69,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:49.605Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
